import React from 'react';
import { Avatar, Box, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';
import { ColorsV2 } from 'app/constants/color';
import { parseAndFormatDate } from 'app/utils';

const FeedListItem = ({ feed, avatarSrc, showDate = true }) => {
  return (
    <ListItem alignItems="flex-start" sx={{ px: 1 }}>
      <ListItemAvatar sx={{ minWidth: 52 }}>
        <Avatar
          sx={{ width: 40, height: 40, boxShadow: 1 }}
          src={
            avatarSrc ||
            'https://media.istockphoto.com/id/1300845620/vector/user-icon-flat-isolated-on-white-background-user-symbol-vector-illustration.jpg?s=612x612&w=0&k=20&c=yBeyba0hUkh14_jgv1OKqIH0CCSWU_4ckRkAoy2p73o='
          }
        />
      </ListItemAvatar>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap:'10px' }}>
        <ListItemText
          primary={
            <Typography variant="subtitle1" color={ColorsV2.white}>
              {feed.title}
            </Typography>
          }
          secondary={
            <Typography component="div" variant='body2'>
              <a
                href={feed.link}
                style={{ textDecoration: 'none', color: ColorsV2.acent }}
                target="_blank"
                rel="noreferrer"
              >
                {feed.link}
              </a>
            </Typography>
          }
        />
        {showDate && (
          <Typography variant="subtitle1" color={ColorsV2.textInfo} mt={-1.5}>
            {parseAndFormatDate(feed.published)}
          </Typography>
        )}
      </Box>
    </ListItem>
  );
};

export default FeedListItem;